import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { Alert } from '@uhg-abyss/web/ui/Alert';
import { isArray, isEmpty } from 'lodash';
import React, { useMemo } from 'react';

import { Table } from './components/Table';

/**
 * Widget: IreRelatedEntities
 *
 * Displays related entities from IRE.
 */
export function IreRelatedEntities({ ireRiskRecord = {} }) {
  const rows = useMemo(() => {
    return isArray(ireRiskRecord?.entityDetails?.[0]?.relatedEntities)
      ? ireRiskRecord.entityDetails?.[0]?.relatedEntities.map((entity) => {
          const matchKey = entity.matchKey || '';

          // Split matchKey into parts at each + or - (keeping the sign), remove empty strings
          const keys = matchKey.split(/(?=[+-])/g).filter(Boolean);

          // Extract all parts starting with +, remove the + sign, then sort alphabetically
          const matchKeyPositive = keys
            .filter((k) => {
              return k.startsWith('+');
            })
            .map((k) => {
              return k.slice(1);
            })
            .sort();

          // Extract all parts starting with -, remove the - sign, then sort alphabetically
          const matchKeyNegative = keys
            .filter((k) => {
              return k.startsWith('-');
            })
            .map((k) => {
              return k.slice(1);
            })
            .sort();

          const dataSources = isArray(entity.senzingRecordSummaries)
            ? entity.senzingRecordSummaries
                .map((summary) => {
                  return summary.dataSource;
                })
                .filter(Boolean)
            : [];

          return {
            ...entity,
            dataSources,
            matchKeyNegative,
            matchKeyPositive,
          };
        })
      : [];
  }, [ireRiskRecord?.entityDetails?.[0]?.relatedEntities]);

  return (
    <ErrorHandler location="src/widgets/RiskRecords/IreRelatedEntities/IreRelatedEntities.jsx">
      {isEmpty(rows) ? (
        <Alert title="There are no related entities from IRE for this risk record." variant="info" />
      ) : (
        <Table rows={rows} />
      )}
    </ErrorHandler>
  );
}
